import { createSelector } from 'reselect';
import { OrderAdditionalServiceGdsServiceServiceType, SeatType } from '@websky/graphql';
import { getSelectedSeats } from './selectedSeats/selectors';
import { getIsActiveDoubleSeat, getPassengersSelectedSeats } from './passengers/selectors';
import { getSelectedSegmentRows } from './seatMap/selectors';
import { getSelectedPassengerFilters } from './selectedPassengersFilters/selectors';
import { getRowsByGroupWithStates } from '../lib/getRowsByGroupWithStates';
import { splitRowsByGroups } from '../lib/splitRowsByGroups';
export const getSelectedSeatsToSave = createSelector(getSelectedSeats, getPassengersSelectedSeats, (selectedSeats, passengersSelectedSeats) => {
    const seatsToSaveMap = new Map();
    passengersSelectedSeats.forEach(selectedSeat => {
        var _a;
        const segmentId = selectedSeat.segment.id;
        const passengerId = selectedSeat.passengerId.toString();
        const serviceId = selectedSeat.seat.number;
        const key = `${segmentId}/${passengerId}`;
        seatsToSaveMap.set(key, [
            ...((_a = seatsToSaveMap.get(key)) !== null && _a !== void 0 ? _a : []),
            {
                segmentId,
                passengerId,
                serviceId,
                service: {
                    segmentId,
                    id: null,
                    row: selectedSeat.row.toString(),
                    letter: selectedSeat.letter,
                    seatType: SeatType.common,
                    type: OrderAdditionalServiceGdsServiceServiceType.Seat
                }
            }
        ]);
    });
    selectedSeats.forEach(seat => {
        var _a;
        const segmentId = seat.segmentId.toString();
        const passengerId = seat.passengerId.toString();
        const serviceId = `${seat.row}${seat.letter}`;
        const key = `${segmentId}/${passengerId}`;
        seatsToSaveMap.set(key, [
            ...((_a = seatsToSaveMap.get(key)) !== null && _a !== void 0 ? _a : []),
            {
                segmentId,
                passengerId,
                serviceId,
                service: {
                    segmentId,
                    id: null,
                    row: seat.row.toString(),
                    letter: seat.letter,
                    seatType: SeatType.common,
                    type: OrderAdditionalServiceGdsServiceServiceType.Seat
                }
            }
        ]);
    });
    return [...seatsToSaveMap.values()].reduce((seats, saveSeats) => [
        ...seats,
        ...saveSeats.map((seat, index) => {
            // The last entry is the new service
            if (index === saveSeats.length - 1) {
                return seat;
            }
            // Previously added services are removed
            return Object.assign(Object.assign({}, seat), { count: 0 });
        })
    ], []);
});
export const getRowsByGroups = createSelector(getSelectedSegmentRows, splitRowsByGroups);
export const getRowsByGroupsDependsOnStates = createSelector(getRowsByGroups, getIsActiveDoubleSeat, getSelectedPassengerFilters, getRowsByGroupWithStates);
